import { useMemo } from "react";
import { useMutation, useQuery } from "urql";
import {
  Card,
  ErrorState,
  LoadingState,
  NotificationPreferenceDocument,
  SetNotificationPreferenceDocument,
} from "visumo-data-agent-web-shared";
import { HelpIcon } from "../help/HelpIcon";
import { useViewer } from "../ViewerContext";
export function NotificationPreferencePanel() {
  const viewer = useViewer();
  const delegated = viewer.role === "CS_DELEGATE";
  const context = useMemo(
    () => ({ additionalTypenames: ["NotificationPreference"] }),
    [],
  );
  const [result, refetch] = useQuery({
    query: NotificationPreferenceDocument,
    context,
    pause: delegated,
  });
  const [saved, save] = useMutation(SetNotificationPreferenceDocument);
  if (delegated) return null;
  const preference = result.data?.notificationPreference;
  const errors = saved.data?.setNotificationPreference.userErrors ?? [];
  return (
    <Card
      title="通知の受け取り方"
      note="時間のかかる処理の結果を、どこで受け取るか選べます。"
      extra={<HelpIcon slug="settings/notification-preferences" />}
    >
      {result.error ? (
        <ErrorState
          title="通知の設定を読み込めませんでした"
          description={result.error.message}
          onRetry={() => refetch({ requestPolicy: "network-only" })}
        />
      ) : !preference ? (
        <LoadingState label="通知の設定を読み込んでいます" />
      ) : (
        <div className="vd-stack">
          {saved.error ? <div role="alert">{saved.error.message}</div> : null}
          {errors.map((error) => (
            <div role="alert" key={error.code}>
              {error.message}
            </div>
          ))}
          <label>
            <input
              type="checkbox"
              checked={preference.inApp}
              disabled={saved.fetching}
              onChange={(event) => {
                void save({
                  input: {
                    inApp: event.target.checked,
                    email: preference.email,
                  },
                }).then(() => refetch({ requestPolicy: "network-only" }));
              }}
            />{" "}
            画面の中で受け取る
          </label>
          <label>
            <input
              type="checkbox"
              checked={preference.email}
              disabled={saved.fetching}
              onChange={(event) => {
                void save({
                  input: {
                    inApp: preference.inApp,
                    email: event.target.checked,
                  },
                }).then(() => refetch({ requestPolicy: "network-only" }));
              }}
            />{" "}
            メールで受け取る
          </label>
          <p className="vd-stat-note">
            画面の中の通知を切ると、処理の結果は通知箱に届きません。メールは入れたときだけ届きます（初期値は切）。
          </p>
          <p className="vd-stat-note">
            サポートによる代行の開始・終了は、この設定にかかわらず画面の中とメールの両方でお知らせします。
          </p>
        </div>
      )}
    </Card>
  );
}
